import React from "react";
import styles	from "./IbpModal.styl"

const DD_DEFAULT = 'Выбрать'
const DD_DEFAULT_TO_PRINT = '----'
const Modal = ({ toggleModal, sendToEmail, onChange, filterData}) => (
	<div className={styles.modalBackground}>
		{ /* Modal box */ }
		<div className={styles.modalBox}>
			{ /* Heading */ }
			<div className={styles.heading}>
				<h1 className={styles.title}>Личные данные</h1>
				<div
					className={styles.symbol}
					onClick={() =>toggleModal()}>
					&#10006;
				</div>
			</div>
			{ /* Content */ }
			<div className={styles.content} >
				<div className={styles.contentItem}>
					<span>ФИО</span>
					<input className={styles.input} type={"text"}  placeholder={'ФИО'} required onChange={(e)=>onChange(e.target.value,'FIO')}/>
				</div>
				<div className={styles.contentItem}>
					<span>Номер телефона</span>
					<input className={styles.input} type={'tel'} placeholder={'+7(***)***-**-**'} required onChange={(e)=>onChange(e.target.value,'phone')}/>
				</div>
				<div className={styles.contentItem}>
					<span>Email</span>
					<input className={styles.input} type={'email'} placeholder={'Введите адрес электронной почты'} required onChange={(e)=>onChange(e.target.value,'email')}/>
				</div>
				<div className={styles.contentItem}>
					<span>Название объекта</span>
					<input className={styles.input} type={'text'} placeholder={'Введите название объекта'} required onChange={(e)=>onChange(e.target.value,'name')}/>
				</div>
				<div className={styles.contentItem}>
					<span>Адрес объекта </span>
					<input className={styles.input} type={'text'} placeholder={'Введите адрес объекта'} required onChange={(e)=>onChange(e.target.value,'address')}/>
				</div>
				<hr/>
				<div className={styles.contentItem}>
					<div>
						<div className={styles.blockHeader}>Полная выходная мощность:</div>
						<div>
							<span>от </span>
							<span> {filterData.minPower} </span>
							<span> до </span>
							<span> {filterData.maxPower} </span>
							<span> кВт </span>
						</div>
					</div>
				</div>
				<div className={styles.contentItem}>
					<div>
						<div className={styles.blockHeader}>
							<span>Число фаз: </span>
							<span>{filterData.phaseNumber === DD_DEFAULT ? DD_DEFAULT_TO_PRINT : filterData.phaseNumber }</span>
						</div>
						<div className={styles.blockHeader}>
							<span>Тип установки: </span>
							<span>{ filterData.mountType === DD_DEFAULT ? DD_DEFAULT_TO_PRINT : filterData.mountType}</span>
						</div>
					</div>
				</div>
				<div className={styles.contentItem}>
					<div>
						<div className={styles.blockHeader}>Тип ИБП</div>
						<div className={styles.flagWrapper}>
							<span>Двойное преобразование (online): </span>
							<span>{filterData.double ? 'Да' : 'Нет' }</span>

							<span>Модульный: </span>
							<span>{filterData.module ? 'Да' : 'Нет' }</span>

							<span>Линейно-интерактивный: </span>
							<span>{filterData.line ? 'Да' : 'Нет' }</span>

							<span>С трансформатором: </span>
							<span>{filterData.transform ? 'Да' : 'Нет' }</span>

							<span>SNMP карта: </span>
							<span>{filterData.snmp ? 'Да' : 'Нет' }</span>

							<span>Наличие встроенного АКБ: </span>
							<span>{filterData.akbPres ? 'Да' : 'Нет' }</span>

							<span>Задано время автаномной работы: </span>
							<span>{filterData.useTime ? 'Да' : 'Нет' }</span>

							<span>Время автономной работы, мин: </span>
							<span>{filterData.time}</span>
						</div>
					</div>
				</div>
				<div className={styles.buttonWrapper}>
					<button onClick={()=>sendToEmail()}>Отправить</button>
				</div>

			</div>
		</div>
	</div>
)
export default Modal;



// WEBPACK FOOTER //
// ./src/react/ui/features/IbpModal/IbpModal.jsx